var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRosterGenders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 3.5C8.09 3.5 3.5 8.089 3.5 13.75C3.5 16.52 4.6 19.032 6.38 20.877C7.11 19.185 8.79 18 10.75 18H16.75C18.71 18 20.39 19.185 21.12 20.877C22.9 19.032 24 16.52 24 13.75C24 8.089 19.41 3.5 13.75 3.5ZM19.9 21.95C19.54 20.542 18.27 19.5 16.75 19.5H10.75C9.23 19.5 7.96 20.542 7.6 21.95C9.31 23.237 11.44 24 13.75 24C16.06 24 18.19 23.237 19.9 21.95ZM2 13.75C2 7.261 7.26 2 13.75 2C20.24 2 25.5 7.261 25.5 13.75C25.5 17.414 23.82 20.687 21.2 22.84C19.17 24.502 16.58 25.5 13.75 25.5C10.92 25.5 8.33 24.502 6.3 22.84C3.68 20.687 2 17.414 2 13.75ZM13.75 8.5C11.94 8.5 10.48 9.958 10.48 11.75C10.48 13.542 11.94 15 13.75 15C15.56 15 17.02 13.542 17.02 11.75C17.02 9.958 15.56 8.5 13.75 8.5ZM8.98 11.75C8.98 9.124 11.12 7 13.75 7C16.38 7 18.52 9.124 18.52 11.75C18.52 14.376 16.38 16.5 13.75 16.5C11.12 16.5 8.98 14.376 8.98 11.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRosterGenders);
export default __webpack_public_path__ + "static/media/ico-rosterGenders.aafb3cdd.svg";
export { ForwardRef as ReactComponent };